/** Ödeme tipi string adları (API / UI). */
export const PaymentTyp = {
  Cash: "Cash",
  NoInstallmentCreditCard: "NoInstallmentCreditCard",
  WithInstallmentCreditCard: "WithInstallmentCreditCard",
  PromissorySale: "PromissorySale",
};

/** @deprecated PaymentTyp ile aynı; geriye dönük import uyumu */
export const PaymentType = PaymentTyp;

/**
 * CollectionReport GetDetails PaymentType query değerleri.
 * Cash = 1, NoInstallmentCreditCard = 2,
 * WithInstallmentCreditCard = 3, PromissorySale = 4
 */
export const PaymentTypes = {
  Cash: 1,
  NoInstallmentCreditCard: 2,
  WithInstallmentCreditCard: 3,
  PromissorySale: 4,
};

/** API özet response `paymentType` string → query id */
export const PAYMENT_TYPE_NAME_TO_ID = {
  Cash: PaymentTypes.Cash,
  NoInstallmentCreditCard: PaymentTypes.NoInstallmentCreditCard,
  WithInstallmentCreditCard: PaymentTypes.WithInstallmentCreditCard,
  PromissorySale: PaymentTypes.PromissorySale,
};

/** Query id → API / i18n key string adı */
export const PAYMENT_TYPE_ID_TO_NAME = {
  [PaymentTypes.Cash]: PaymentTyp.Cash,
  [PaymentTypes.NoInstallmentCreditCard]: PaymentTyp.NoInstallmentCreditCard,
  [PaymentTypes.WithInstallmentCreditCard]: PaymentTyp.WithInstallmentCreditCard,
  [PaymentTypes.PromissorySale]: PaymentTyp.PromissorySale,
};

/**
 * paymentType değerini (string ad veya sayı) GetDetails query id'sine çevirir.
 * @param {string|number|null|undefined} value
 * @returns {number|null}
 */
export function resolvePaymentTypeId(value) {
  if (value == null || value === "") return null;
  const asNumber = Number(value);
  if (
    asNumber === PaymentTypes.Cash ||
    asNumber === PaymentTypes.NoInstallmentCreditCard ||
    asNumber === PaymentTypes.WithInstallmentCreditCard ||
    asNumber === PaymentTypes.PromissorySale
  ) {
    return asNumber;
  }
  const name = String(value);
  return PAYMENT_TYPE_NAME_TO_ID[name] ?? null;
}

export default PaymentTyp;
